import React from 'react';
import moment from 'moment';

import { T } from '../../../../../../common/locale/translate';
import TextArea from '../../../contact/components/contact_form/textarea';
import TextInput from '../../../contact/components/contact_form/input';
import { Validate } from '../../../../../../common/validation/validate';
import { trackAdWordsConversion } from '../../../../services/adWords';
import { ask_for_offer } from '../../../../services/services';
import { trackAnalyticsEvent } from '../../../../services/analytics';

export default class AskForOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_open: false,
      token: this.props.token,
      params: this.props.params,

      fullName: '',
      email: '',
      phoneNumber: '',
      departureDate:
        this.props.params && this.props.params.departure_date
          ? moment.unix(this.props.params.departure_date).format('YYYY-MM-DD')
          : '',
      returnDate:
        this.props.params && this.props.params.return_date
          ? moment.unix(this.props.params.return_date).format('YYYY-MM-DD')
          : '',
      tripLength:
        this.props.params &&
        this.props.params.duration_min &&
        this.props.params.duration_max
          ? `${this.props.params.duration_min}-${
              this.props.params.duration_max
            } ${T('days')}`
          : '',
      peopleCount:
        this.props.params &&
        (this.props.params.adults_number || this.props.params.children_ages)
          ? `${this.props.params.adults_number} ${T(
              parseInt(this.props.params.adults_number) > 1
                ? 'adults_selected_plural'
                : 'adult'
            )}` +
            (this.props.params.children_ages
              ? `, ${this.props.params.children_ages
                  .split(',')
                  .length.toString()} ${T(
                  parseInt(this.props.params.children_ages.split(',').length) >
                  1
                    ? 'children_selected_plural'
                    : 'child'
                )} (${T('age')}: ${this.props.params.children_ages.replaceAll(
                  ',',
                  ', '
                )})`
              : '')
          : '',
      preferredAirport:
        this.props.params && this.props.params.departure_airports
          ? this.props.params.departure_airports
          : '',
      message: '',
      agreementRules: false,
      agreementSend: false,

      fullName_class: '',
      email_class: '',
      phoneNumber_class: '',
      departureDate_class: '',
      returnDate_class: '',
      tripLength_class: '',
      peopleCount_class: '',
      preferredAirport_class: '',
      message_class: '',
      agreementRules_class: '',
      agreementSend_class: '',

      offer: this.props.offer,
      is_sent: false,
      newsletter_sign_up: false,
      title: T('ask_for_offer_name'),
      is_sent_header: T('message_is_sent'),
      is_sent_message: T('message_is_sent_content'),

      type: this.props.type
    };
  }

  render() {
    return (
      <div
        className={`ask-for-offer-button ${this.props.className}`}
        title={`${T('ask_us_about_offer')}`}
      >
        <div>
          <span
            className="ask-for-offer-name"
            onClick={this.togglePopupVisibility}
          >
            <i className="fa fa-question-circle-o" />
            {this.state.title}
          </span>
        </div>
        {this.state.is_open && this.renderFormPopup()}
      </div>
    );
  }

  togglePopupVisibility = () => {
    this.setState({ is_open: !this.state.is_open });
  };

  handleChange = (inputName, inputValue) => {
    this.setState({ [inputName]: inputValue });
  };

  handleSubmit = () => {
    let validation = {
      email: this.validateField('email'),
      agreementRules: this.validateCheckbox('agreementRules'),
      agreementSend: this.validateCheckbox('agreementSend')
    };

    let is_form_valid = true;
    Object.keys(validation).forEach(function(key) {
      //check if form is valid
      if (validation[key] == false) {
        is_form_valid = false;
      }
    });
    if (!is_form_valid) {
      return;
    }

    ask_for_offer(this.questionData(), this.state.token)
      .then(() => {
        this.setState({ is_sent: true });
        trackAdWordsConversion(715672677, 'pmoQCL2jt3IQrZTnlwM');
        trackAnalyticsEvent(
          'oferty',
          'wysłanie zapytania o ofertę',
          'wysłanie zapytania o ofertę'
        );
        if (this.state.newsletter_sign_up) {
          trackAnalyticsEvent(
            'newsletter',
            'zapis do newslettera',
            'zapis z zapytania o ofertę'
          );
        }
      })
      .catch(error => {
        console.log('Error occurred: ' + error);
      });
  };

  validateField = fieldName => {
    let fieldValue = this.state[fieldName];

    if (!Validate.byType(fieldName, fieldValue)) {
      this.setState({
        [fieldName + '_class']: 'invalid'
      });
      return false;
    } else {
      this.setState({ [fieldName + '_class']: '' });
      return true;
    }
  };

  validateCheckbox = fieldName => {
    let fieldValue = this.state[fieldName];

    if (!fieldValue) {
      this.setState({
        [fieldName + '_class']: 'invalid'
      });
      return false;
    } else {
      this.setState({ [fieldName + '_class']: '' });
      return true;
    }
  };

  questionData = () => ({
    client: {
      full_name: this.state.fullName,
      email: this.state.email,
      phone_number: this.state.phoneNumber,
      departure_date: this.state.departureDate,
      return_date: this.state.returnDate,
      trip_length: this.state.tripLength,
      people_count: this.state.peopleCount,
      preferred_airport: this.state.preferredAirport,
      note: this.state.message,
      url: window ? window.location.href : null
    },
    offer: this.state.offer,
    type: this.state.type,
    newsletter: this.state.newsletter_sign_up
  });

  handleAgreementRulesChange = () => {
    this.setState({
      agreementRules: !this.state.agreementRules
    });
  };

  handleAgreementSendChange = () => {
    this.setState({
      agreementSend: !this.state.agreementSend
    });
  };

  handleNewsletterSignUpChange = () => {
    this.setState({
      newsletter_sign_up: !this.state.newsletter_sign_up
    });
  };

  renderHeader = () => (
    <header>
      <h3>{T('form_title')}</h3>
      <p>{T('sub_title')}</p>
    </header>
  );

  renderFormPopup = () => (
    <div className="ask-for-offer-popup">
      <div className="content">
        <span
          onClick={this.togglePopupVisibility}
          className="close fa fa-times"
          aria-hidden="true"
        />
        {this.state.is_sent ? '' : this.renderHeader()}
        <div className={`${this.state.is_sent ? 'hidden' : ''}`}>
          <TextInput
            label={T('full_name')}
            name="fullName"
            class={this.state.fullName_class}
            id="question-name"
            onChangeCallback={this.handleChange}
            validationMessage={T('full_name_notification')}
            ref="fullName"
          />
          <TextInput
            label={'*' + T('email_address')}
            name="email"
            class={this.state.email_class}
            id="question-email"
            onChangeCallback={this.handleChange}
            validationMessage={T('email_notification')}
            ref="email"
          />
          <TextInput
            label={T('phone_number')}
            name="phoneNumber"
            class={this.state.phoneNumber_class}
            id="question-phone"
            onChangeCallback={this.handleChange}
            validationMessage={T('phone_number_notification')}
            ref="phoneNumber"
          />
          <TextInput
            initialValue={this.state.departureDate}
            label={T('departure_date_capital')}
            name="departureDate"
            class={this.state.departureDate_class}
            id="question-departure"
            onChangeCallback={this.handleChange}
            ref="departureDate"
            type="date"
          />
          <TextInput
            initialValue={this.state.returnDate}
            label={T('arrival_date_capital')}
            name="returnDate"
            class={this.state.returnDate_class}
            id="question-return"
            onChangeCallback={this.handleChange}
            ref="returnDate"
            type="date"
          />
          <TextInput
            initialValue={this.state.tripLength}
            label={T('trip_length')}
            name="tripLength"
            class={this.state.tripLength_class}
            id="question-trip-length"
            onChangeCallback={this.handleChange}
            ref="tripLength"
          />
          <TextInput
            initialValue={this.state.peopleCount}
            label={T('people_count')}
            name="peopleCount"
            class={this.state.peopleCount_class}
            id="question-people-count"
            onChangeCallback={this.handleChange}
            ref="peopleCount"
          />
          <TextInput
            initialValue={this.state.preferredAirport}
            label={T('preferred_airport')}
            name="preferredAirport"
            class={this.state.preferredAirport_class}
            id="question-preferred-airport"
            onChangeCallback={this.handleChange}
            ref="preferredAirport"
          />
          <TextArea
            label={T('additional_comments')}
            name="message"
            class={this.state.message_class}
            id="question-note"
            onChangeCallback={this.handleChange}
            validationMessage={T('message_content_notification')}
            ref="message"
          />
          <div className="agreement">
            <input
              type="checkbox"
              className="filled-in"
              id="agreement-rules"
              checked={this.state.agreementRules}
              onChange={this.handleAgreementRulesChange}
            />
            <label htmlFor="agreement-rules">
              {'* '}
              {T('agreement_rules')}{' '}
            </label>
            {this.state.agreementRules_class === 'invalid' && (
              <div className="validation-message">
                {T('must_accept_agreement')}
              </div>
            )}
          </div>
          <div className="agreement">
            <input
              type="checkbox"
              className="filled-in"
              id="agreement-send"
              checked={this.state.agreementSend}
              onChange={this.handleAgreementSendChange}
            />
            <label htmlFor="agreement-send">
              {'* '}
              {T('agreement_send')}{' '}
            </label>
            {this.state.agreementSend_class === 'invalid' && (
              <div className="validation-message">
                {T('must_accept_agreement')}
              </div>
            )}
          </div>
          <div className="subscribe-to-newsletter">
            <input
              type="checkbox"
              className="filled-in"
              id="subscribe-to-newsletter"
              checked={this.state.newsletter_sign_up}
              onChange={this.handleNewsletterSignUpChange}
            />
            <label htmlFor="subscribe-to-newsletter">
              {' '}
              {T('sign_to_newsletter')}{' '}
            </label>
            {this.state.newsletter_sign_up && (
              <span className="newsletter-confirmation-mail-information">
                {T('newsletter_after_sign_up')}
              </span>
            )}
          </div>
          <button onClick={this.handleSubmit} className="submit">
            {T('send_message')}
          </button>
        </div>
        <div className={`message ${!this.state.is_sent ? ' hidden' : ''}`}>
          <h4>{this.state.is_sent_header}</h4>
          <p>{this.state.is_sent_message}</p>
          <button onClick={this.togglePopupVisibility} className="submit">
            {T('close')}
          </button>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/ask_for_offer/ask_for_offer.jsx